import { AppContext } from './AppProvider'
import { useContext } from 'react'

export const usePageActivated = () => {
  const ctx = useContext(AppContext)

  return ctx.active
}
